import apiBaseUrl from '../../utils/config';

class DoctorSummaryService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/doctor-summary`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.getToken()}`
    };
  }

  async adjustSummary(doctorId, hours, pay) {
    const response = await fetch(`${this.baseUrl}/adjust/${doctorId}?hours=${hours}&pay=${pay}`, {
      method: 'PUT',
      headers: this.getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to adjust summary');
    return response.text();
  }

  async updateHourlyRate(doctorId, rate) {
    const response = await fetch(`${this.baseUrl}/rate/${doctorId}?rate=${rate}`, {
      method: 'PUT',
      headers: this.getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to update rate');
    return response.text();
  }

  async exportCsv() {
    const response = await fetch(`${this.baseUrl}/export`, {
      headers: this.getAuthHeaders(),
    });
    if (!response.ok) throw new Error('CSV export failed');

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'summaries.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}

export default DoctorSummaryService;
